import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteSubscriptionsMutation} from '../hooks/useSubscriptionsQuery';

interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

/**
 * FNP-918: batch delete through the shared confirmation button (§2).
 *
 * It reaches for the delete MUTATION hook directly rather than the whole
 * `useSubscriptions` list hook. Under the infinite query the list hook mounts a
 * paginated query of its own, so calling it here put a second copy of the
 * entire subscriptions list in the page header just to get at one callback.
 */
export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const deleteMutation = useDeleteSubscriptionsMutation();

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedIds.length === 0 || deleteMutation.isPending}
            recordIdsLength={selectedIds.length}
            handleConfirm={() => {
                if (selectedIds.length === 0) {
                    return;
                }
                // Selection is cleared only once the delete has SETTLED —
                // clearing synchronously alongside a fire-and-forget mutate
                // drops the ids the retry would need.
                deleteMutation.mutate(selectedIds, {
                    onSuccess: () => onDeleteComplete?.(),
                });
            }}
        />
    );
};
